module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xitongxiaoxi"
  }, [_c('div', {
    staticClass: "xt-title"
  }, [_c('span', {
    staticClass: "xt-title-span"
  }, [_vm._v(_vm._s(_vm.$t('all.wentibangzhu')))]), _vm._v(" "), _c('span', {
    staticClass: "xt-title-span1",
    on: {
      "click": _vm.handleUploadFk
    }
  }, [_vm._v(_vm._s(_vm.$t('all.woyaofankui')))])]), _vm._v(" "), _c('div', {
    staticClass: "xt-list"
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item.id || index,
      staticClass: "wt-list-item"
    }, [(index == 0) ? _c('img', {
      attrs: {
        "src": require("../../assets/image/wenda_1@2x.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      attrs: {
        "src": require("../../assets/image/wenda_2@2x.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      attrs: {
        "src": require("../../assets/image/wenda_3@2x.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (index == 3) ? _c('img', {
      attrs: {
        "src": require("../../assets/image/wenda_4@2x.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (index == 4) ? _c('img', {
      attrs: {
        "src": require("../../assets/image/wenda_5@2x.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "wt-list-item-box"
    }, [_c('div', {
      staticClass: "wt-list-item-box-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "wt-list-item-box-content"
    }, [_vm._v(_vm._s(item.content))])])])
  }), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06b04941"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wentibangzhu/wentibangzhu.vue
// module id = 941
// module chunks = 1